import DropDown from "views/pages/DataPage/CardsView/DataPageFilters/DropDown";
import { isValidEntityType, RelevanceItems } from "types";
import { useEffect, useMemo, useRef, useState } from "react";
import ChevronIcon from "assets/icons/ChevronIcon";
import styles from "./style.module.scss";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { getRelevanceScores } from "redux/SingleDataset/selectors";
import useQueryParam from "hooks/useQueryParam";
import {
  ENTITY_TYPE_PARAMETER,
  PAGE_PARAMETER,
  SEARCH_TEXT_THRESHOLD_PARAMETER,
} from "helpers/constants/miscellaneous";
import { useNavigate, useLocation } from "react-router-dom";
import { setCardslistLoading } from "redux/SingleDataset/actions";

const RelevanceButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const [showDropdown, setShowDropdown] = useState(false);
  const filterRef = useRef<HTMLDivElement>(null);
  const entitySearchParam = useQueryParam(ENTITY_TYPE_PARAMETER);
  const entityParams = isValidEntityType(entitySearchParam)
    ? entitySearchParam
    : null;
  const relevanceScores = useSelector((state: any) =>
    getRelevanceScores(state, entityParams)
  );

  const items: RelevanceItems[] = [
    { id: 0, text: "High", score: relevanceScores[0] },
    { id: 1, text: "Medium", score: relevanceScores[1] },
    { id: 2, text: "Low", score: relevanceScores[2] },
  ];
  const selectedThreshold = Number(
    useQueryParam(SEARCH_TEXT_THRESHOLD_PARAMETER)
  );
  let selectedId = 1;
  if (
    selectedThreshold &&
    items.find((item) => item.score === selectedThreshold)
  ) {
    selectedId = items.find((item) => item.score === selectedThreshold)!.id;
  }
  const selectedTitle = items.find((item) => item.id === selectedId)!.text;

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleSelect = (id: number) => {
    setShowDropdown(false);
    if (id === selectedId) {
      return;
    } else {
      dispatch(setCardslistLoading(true));
      searchParams.set(
        SEARCH_TEXT_THRESHOLD_PARAMETER,
        (items.find((item) => item.id === id)?.score || 0).toString()
      );
      searchParams.set(PAGE_PARAMETER, "1");
      navigate({ search: `?${searchParams.toString()}` });
    }
  };

  const handleOutsideClick = (event: any) => {
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    if (showDropdown) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    //eslint-disable-next-line
  }, [showDropdown]);

  return (
    <div className={styles.relevanceButtonContainer} ref={filterRef}>
      <div
        className={classNames(styles.header, {
          [styles.openedHeader]: showDropdown,
        })}
        data-testid="relevance-button"
        onClick={toggleDropdown}
      >
        <div className={styles.titleContainer}>
          <div className={styles.relevanceTitle}>Minimum Relevance</div>
          <div className={styles.selectedTitle}>{selectedTitle}</div>
        </div>
        <div className={styles.toggleIcon}>
          {showDropdown ? (
            <ChevronIcon direction="up" />
          ) : (
            <ChevronIcon direction="down" />
          )}
        </div>
      </div>

      {showDropdown && (
        <div className={styles.childWrapper}>
          <DropDown
            items={items}
            variant="light"
            showRadioButton={false}
            classname={styles.dropdown}
            selectedItemsIds={[selectedId]}
            onItemSelection={handleSelect}
          />
        </div>
      )}
    </div>
  );
};

export default RelevanceButton;
